import React from 'react';
import {Icon, IconButton, withStyles} from '@material-ui/core';
import _ from '@lodash';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import * as Actions from 'app/store/actions';
import connect from 'react-redux/es/connect/connect';

const styles = theme => ({
    Icon: {
        color: theme.palette.type === 'dark' ? '#fff' : '#616161'
    }
});

const NavbarFoldedToggleButton = ({settings, setDefaultSettings, children, className, classes}) => {
    return (
        <IconButton
            className={classNames(classes.Icon, className)}
            onClick={() => {
                setDefaultSettings(_.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded));
            }}
        >
            {children}
        </IconButton>
    );
};

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        setDefaultSettings: Actions.setDefaultSettings
    }, dispatch);
}

function mapStateToProps({fuse})
{
    return {
        settings: fuse.settings.current
    }
}

NavbarFoldedToggleButton.defaultProps = {
    children: <Icon>menu</Icon>
};

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(NavbarFoldedToggleButton));
